module.exports = __webpack_public_path__ + "img/front.4b962106.jpg";